import Alpine from "alpinejs"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"

// import 'swiper/css/pagination';

Alpine.data('ImageSwiper', () => ({
    init(){
        const swiper = new Swiper(this.$el.querySelector('.imageSwiper'), {
            modules: [Navigation, Pagination],
            centeredSlides: true,
            navigation: {
                nextEl: this.$el.querySelector('.swiper-navigation-right'),
                prevEl: this.$el.querySelector('.swiper-navigation-left'),
            },
            pagination: {
                el: this.$el.querySelector(".swiper-pagination"),
                clickable: true,
                bulletClass: 'block w-2 h-2 rounded-full border-1 border-primary cursor-pointer',
                bulletActiveClass: 'bg-primary',
            }
        });
    }
}))